// BlockRenderer — мапить типи блоків з backend у відповідні UI-компоненти.

import CategoryListBlock from "./CategoryListBlock";
import ProductListBlock from "./ProductListBlock";
import ProductLinksBlock from "./ProductLinksBlock";
import CatalogLinkBlock from "./CatalogLinkBlock";
import OrderCardBlock from "./OrderCardBlock";
import UnknownBlock from "./UnknownBlock";

export default function BlockRenderer({ block, onAction }) {
  switch (block.type) {
    case "category_list":
      return <CategoryListBlock block={block} onAction={onAction} />;

    case "product_list":
      return <ProductListBlock block={block} onAction={onAction} />;

    case "product_links":
      return <ProductLinksBlock block={block} onAction={onAction} />;

    case "catalog_link":
      return <CatalogLinkBlock block={block} onAction={onAction} />;

    case "order_card":
      return <OrderCardBlock order={block.order} />;

    default:
      return <UnknownBlock block={block} />;
  }
}